import { apiRequest } from './http';
import type { Level } from './types';
import type { AppStage } from './types';
export type { AppStage } from './types';

export const APP_STAGES = ['STAGE_1', 'STAGE_2', 'STAGE_3', 'STAGE_4', 'STAGE_5', 'UA_OPS'] as const satisfies readonly AppStage[];
export interface StageGrant { stage: AppStage; level: Level }
export interface StageGrants { email: string; stages: AppStage[]; grants: StageGrant[] }
export interface StageGrantChange { stage: AppStage; level: Level | null }
export interface StageGrantChanges { email: string; changes: StageGrantChange[] }

export function getMemberStageGrants(email: string, signal: AbortSignal) {
  return apiRequest<StageGrants>(`/apps/stage-grants/${encodeURIComponent(email)}`, { signal });
}

// BigQuery dataset ACL 반영 결과. Stage 권한(앱 조회 권한)을 BQ 권한이 그대로 따라간다.
export type StageBqSyncStatus = 'done' | 'failed' | 'skipped';
export interface StageGrantResult extends StageGrantChanges {
  state: 'synced';
  sync_job_id?: string | null;
  bq_sync_status?: StageBqSyncStatus;
  bq_sync_error?: string | null;
  prefixes?: string[];
}

export function changeStageGrants(body: StageGrantChanges, operationId: string) {
  return apiRequest<StageGrantResult>('/apps/stage-grants', {
    method: 'PATCH', body, headers: { 'Idempotency-Key': operationId },
  });
}
